/* eslint-disable react/no-unknown-property */
import React, { FC } from 'react';

import { Box, Grid, Stack, Typography } from '@mui/material';
import { Wormhole } from 'src/v2/components/ui/images';

import { primaryColors } from '~components/theme/styles/colors';

import SlideWrapper from '../SlideWrapper';

const SolvePanel: FC<{ img?: string; text1: string; text2: string; reverse?: boolean }> = ({
  text1,
  text2,
  reverse,
}) => {
  return (
    <Grid
      container
      direction={{ xs: 'column-reverse', sm: reverse ? 'row-reverse' : 'row' }}
      justifyContent={'center'}
      alignItems={'center'}
      spacing={1}
    >
      <Grid item xs={6} pr={2}>
        <Box sx={{ textAlign: 'left', pt: { xs: 8, sm: 0 } }}>
          <Typography variant={'h5'} color={primaryColors[100]}>
            {text1}
          </Typography>
          <Typography mt={2} variant={'body1'} color={primaryColors[400]}>
            {text2}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={6} textAlign={'center'} mt={{ xs: 4, sm: 0 }}>
        <Wormhole />
      </Grid>
    </Grid>
  );
};

function SolveProblemsSlide() {
  return (
    <SlideWrapper
      sx={{
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Stack spacing={8}>
        <Typography variant={'h4'} mt={4}>
          Solving significant financial problems through innovative solutions.
        </Typography>
        <Typography variant={'body1'} mt={4} mb={8} color={primaryColors[400]}>
          Vesta aims to drive lasting impact and create long-term value through financial innovation that
          addresses significant problems.
        </Typography>
        <SolvePanel
          reverse
          text1="Continuously striving for breakthrough innovation"
          text2="Innovation is at the core of Vesta! An inclusive financial future will come from cutting-edge solutions."
        />
        <SolvePanel
          text1="Empowering people through clear financial demystification"
          text2="Financial innovations should be accessible to everyone. Large efforts are put in presenting complex financial concepts in simple and easy-to-understand ways."
        />
        <SolvePanel
          reverse
          text1="Pushing the limits while promoting a positive and healthy culture"
          text2="At Vesta, we believe that a positive environment is the key to promote creativity and experimentation."
        />
        <SolvePanel
          text1="Elevating the standard of excellence"
          text2="The best is not enough for our users. We are dedicated to meeting the highest expectations through exceptional standards."
        />
      </Stack>
    </SlideWrapper>
  );
}

export default SolveProblemsSlide;
